import React from "react";
import { useTranslation } from "react-i18next";
import "./whatIs.scss";

const WhatIs = () => {
    const { t } = useTranslation()

    return (
        <div className="container-what-is">
            <div className="texts-what-is">
                <h1>{t("realtime_data.what_is.title")}</h1>
                <p>{t("realtime_data.what_is.section_text_1")}</p>
                <p>{t("realtime_data.what_is.section_text_2")}</p>
            </div>
        </div>
    )
}
export default WhatIs;